import { Appointment } from "services/types/appointments.type";
import { PersonalEvent, AppointmentBlock } from "services/types/events.type";

interface PatientData {
  patient: any | null;
  preferredClinic: any | null;
  preferredProvider: any | null;
  patientReferralSource: number | null;
  patientSubReferralSource: number | null;
}

export const getAppointmentPatientData = (
  appointment: Appointment | PersonalEvent | AppointmentBlock
): PatientData => {
  const patient = "patient" in appointment ? appointment?.patient : null;

  const preferredClinic =
    "patient" in appointment ? appointment?.patient?.preferred_clinic : null;

  const preferredProvider =
    "patient" in appointment ? appointment?.patient?.preferred_provider : null;

  const patientReferralSource =
    "patient" in appointment
      ? appointment?.patient?.referral_source?.id ?? null
      : null;

  const patientSubReferralSource =
    "patient" in appointment
      ? appointment?.patient?.sub_referral_source?.id ?? null
      : null;

  return {
    patient,
    preferredClinic,
    preferredProvider,
    patientReferralSource,
    patientSubReferralSource,
  };
};
